/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Subheading_BoldInputs */

const en_hero_subheading_bold = /** @type {(inputs: Hero_Subheading_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`75% of search queries go to the top 3 results on Google Maps.`)
};

/** @type {(inputs: Hero_Subheading_BoldInputs) => LocalizedString} */
const et_hero_subheading_bold = () => /** @type {LocalizedString} */ ('hero_subheading_bold')

/**
* | output |
* | --- |
* | "75% of search queries go to the top 3 results on Google Maps." |
*
* @param {Hero_Subheading_BoldInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_subheading_bold = /** @type {((inputs?: Hero_Subheading_BoldInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Subheading_BoldInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_subheading_bold(inputs)
	return en_hero_subheading_bold(inputs)
});